import { useEffect, useMemo, useState } from "react"
import { AutoComplete, Spin } from "antd"
import debounce from "lodash.debounce"
import apiClient from "../../Utils/apiClient"

const AutoCompleteBox = ({
  name,
  endPoint,
  style,
  className,
  placeholder,
  onSelect,
  onChange,
  value,
  label,
}) => {
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const [displayValue, setDisplayValue] = useState("")

  useEffect(() => {
    setDisplayValue(value || "")
  }, [value])

  const fetchOptions = async (text) => {
    if (!text) return
    setLoading(true)
    try {
      let payload
      if (endPoint === "devices/identifiers") {
        payload = { search: text }
      } else {
        payload = { [name]: text }
      }

      const data = await apiClient(`filter/${endPoint}`, "POST", payload)

      if (data.success) {
        const labelSet = new Set()
        const formattedOptions = []

        data.result.forEach((item) => {
          if (endPoint === "devices/identifiers") {
            const optionLabel = `${item[name]}`
            if (optionLabel && !labelSet.has(optionLabel.toLowerCase())) {
              labelSet.add(optionLabel.toLowerCase())
              formattedOptions.push({
                value: item[name],
                label: optionLabel,
              })
            }
          } else {
            const optionLabel = item[name]
            if (optionLabel && !labelSet.has(optionLabel.toLowerCase())) {
              labelSet.add(optionLabel.toLowerCase())
              formattedOptions.push({
                value: optionLabel,
                label: optionLabel,
              })
            }
          }
        })

        setOptions(formattedOptions)
      }
    } catch (error) {
      console.error("Autocomplete fetch error:", error)
      setOptions([])
    } finally {
      setLoading(false)
    }
  }

  const debounceFetcher = useMemo(
    () => debounce(fetchOptions, 300),
    [name, endPoint]
  )

  useEffect(() => {
    return () => debounceFetcher.cancel()
  }, [debounceFetcher])

  return (
    <>
      {label ? <label className="mb-1 d-block">{label}</label> : null}
      <AutoComplete
        options={options}
        className={className}
        onSelect={(value, option) => {
          setDisplayValue(option.label)
          if (onSelect) onSelect(value, option)
        }}
        onSearch={debounceFetcher}
        onChange={(val) => {
          setDisplayValue(val)
          if (onChange) onChange(val)
        }}
        style={style || { width: 200 }}
        placeholder={placeholder}
        allowClear
        value={displayValue}
        notFoundContent={loading ? <Spin size="small" /> : "No results"}
      />
    </>
  )
}

export default AutoCompleteBox
